import React, { createContext, useState, useEffect } from 'react';
import { site_url } from "./config.js";
import { parseStoredAccessToken } from "./parseStoredAccessToken.js";
import axios from 'axios';
export const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Stores the logged-in user's token
  const [loading, setLoading] = useState(true); // To handle loading state
  const [fulluser, setfullUser] = useState(null); // Stores the logged-in user's token
  const [hasRedirectedOnce, setHasRedirectedOnce] = useState(false);



  useEffect(() => {
    const savedToken = localStorage.getItem('access_token');
    if (savedToken) {
      setUser(parseStoredAccessToken(savedToken) ?? savedToken);
    }
    setLoading(false);
  }, []);

  // Login function to set user and token
  const login = (token) => {
    setUser(token);
    localStorage.setItem('access_token', token);
  };

  // Logout function to clear user and token
  const logout = () => {
    setUser(null);
    localStorage.removeItem('access_token');
  };
  useEffect(() => {
    Userdetails();

  }, []);

  
  const Userdetails = async () => {
    const token = parseStoredAccessToken(localStorage.getItem('access_token'));
if (token) {
  axios.get(site_url + "/authcustomer_details", {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  })
  .then(res => {
    setfullUser(res.data.data);
  })
  .catch(err => {
    console.error("API Error:", err.response.data);
  });
}
  };
  

  return (
    <AuthContext.Provider value={{ hasRedirectedOnce, setHasRedirectedOnce, user,setUser, loading, login, logout,fulluser,setfullUser }}>
      {children}
    </AuthContext.Provider>
  );
};
